import { defineComponent } from 'vue';

const name = "g-date-input";

export default defineComponent({
  name,

  components: {},

  props: {
    invertido: {
      type: Boolean,
      default: false,
    },
    dataPassadas:{
      type:Boolean,
      default:false
    },
    modelValue: {
      type: [String, Date]
    },
    alturainput: {
      type: String,
      default: "40px",
    },
    largurainput: {
      type: String,
      default: "200px",
    },
    tamanhobotao: {
      type: String,
      default: "40px",
    },
    placeholderinput: {
      type: String,
      default: "Escolha uma data",
    },
    disabled:{
      type:Boolean,
      default:false
    },
    permiteDataPassadas: {
      type: Boolean,
      default: false,
    },
    retornaDateTime: {
      type: Boolean,
      default: false,
    },
    DataMinima:{
      type: Date,
      default: null,
    },
    DataMaxima:{
      type: Date,
      default: null
    }
  },

  mounted() {
    this.dataAtual = new Date()
  },

  updated() {},

  data() {
    return {
      valorTexto: this.modelValue,
      valorData: null,
      responsiveOptions: [
        {
          breakpoint: "1400px",
          numMonths: 2,
        },
        {
          breakpoint: "1200px",
          numMonths: 1,
        },
      ],
      novaData: new Date(),
    };
  },

  methods: {
    atualizaData() {      

      var dataDesmontada = this.valorTexto.split("/");
      let dataValida = !isNaN(Date.parse(`${dataDesmontada[1]}/${dataDesmontada[0]}/${dataDesmontada[2]}`));

      if(dataValida && dataDesmontada[1] <= 12) {
        this.valorData = new Date(
          dataDesmontada[2],
          dataDesmontada[1] - 1,
          dataDesmontada[0]
        );
        
        return
      }
      
      this.valorTexto = '';
    },

    validarData(dataInserida) { // impedir que a data inserida seja menor que a atual
      return dataInserida < this.dataAtual  ? this.dataAtual : dataInserida
    },

    getAno() {           
      this.valorTexto = this.novaData
    },
  },

  watch: {
    valorData(novoValor) {
      if(!this.dataPassadas)
        novoValor = this.validarData(novoValor)

      if(this.retornaDateTime) {
        if((this.DataMaxima) && novoValor > this.DataMaxima) {
          this.$emit('update:modelValue', this.DataMaxima);
          return
        }
        this.$emit('update:modelValue', novoValor);
        return
      }

      this.valorTexto = new Intl.DateTimeFormat('pt-BR').format(novoValor);
    },

    valorTexto(novoValor) {
      let regex = /([0-9]{2})[/]([0-9]{2})/      

      if(novoValor.match(regex)) {
        this.novaData = novoValor
        // .replace(novoValor, novoValor.slice(0, 6)+'2023')
      } else {
        this.novaData = ''
      }

      if(!this.retornaDateTime) {
        if((this.DataMaxima) && this.novaData > this.DataMaxima) {
          this.$emit('update:modelValue', this.DataMaxima);
          return
        }
        this.$emit('update:modelValue', this.novaData);
      }
    },

    modelValue(valor) {      
      if(this.retornaDateTime) {
        this.valorTexto = new Intl.DateTimeFormat('pt-BR').format(valor)
        return;
      }

      this.valorTexto = valor;
    }
  },

  computed: {
    BtnInvertido() {
      return this.invertido ? 'row-reverse' : 'row'
    },
  },
});
